import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export function CompletionStep() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-4">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ 
          type: "spring",
          stiffness: 260,
          damping: 20,
          delay: 0.1 
        }}
        className="mb-6"
      >
        <CheckCircle2 className="h-16 w-16 text-green-500" />
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.3 }}
      >
        <h2 className="text-2xl md:text-3xl font-bold mb-3">You're all set! 🎉</h2>
        <p className="text-gray-400 text-sm md:text-base mb-6 max-w-md mx-auto">
          Thank you for completing your profile. You're ready to explore Strykr's financial insights.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            size="lg" 
            className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-md"
          >
            Go to Dashboard
          </Button>
          
          <Button 
            variant="outline" 
            size="lg"
            className="w-full sm:w-auto border-white/10 bg-white/5 hover:bg-white/10 transition-colors"
          >
            Explore Premium Features
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
